export class AddToCartError extends Error {
  constructor(message) {
    super(message)
    this.name = "AddToCartError"
  }
};